// // import React from "react";
// // import { Link } from "react-router-dom";
// // import articles from "./ArticlesBulk";

// // const Articles = () => {
// //   return (
// //     <div className="min-h-screen bg-gray-50 py-10 px-5">
// //       <h1 className="text-3xl font-bold text-center mb-10 text-gray-800">
// //          Articles
// //       </h1>
// //       <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
// //         {articles.map((article) => (
// //           <Link key={article.id} to={`/${article.id}`}>
// //             <div className="bg-white shadow-lg rounded-2xl p-6 hover:shadow-2xl transition-shadow duration-300">
// //               <h2 className="text-xl font-semibold text-gray-900 mb-2">
// //                 {article.title}
// //               </h2>
// //               {/* <p className="text-gray-600 mb-4">{article.description}</p> */}
// //               <div className="border-t border-gray-200 pt-3">
// //                 <h3 className="text-lg font-medium text-indigo-600">
// //                   {article.description}
// //                 </h3>

// //               </div>
// //             </div>
// //           </Link>
// //         ))}
// //       </div>
// //     </div>
// //   );
// // };

// // export default Articles;



// // import React from "react";
// // import { Link } from "react-router-dom";
// // import articles from "./ArticlesBulk";
// // import AdManagerAd from "../JobDetails/AdsenseAd";

// // const Articles = () => {
// //   return (
// //     <div className="min-h-screen bg-gray-50 py-10 px-5">
// //       <h1 className="text-3xl font-bold text-center mb-10 text-gray-800">
// //         Articles
// //       </h1>

// //       <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
// //         {articles.map((article, index) => (
// //           <React.Fragment key={article.id}>

// //             {/* Article Card */}
// //             <Link to={`/articles/${article.id}`}>
// //               <div className="bg-white shadow-lg rounded-2xl p-6 hover:shadow-2xl transition-shadow duration-300 cursor-pointer">
// //                 <h2 className="text-xl font-semibold text-gray-900 mb-2">
// //                   {article.title}
// //                 </h2>

// //                 <div className="border-t border-gray-200 pt-3 mt-3">
// //                   <h3 className="text-lg font-medium text-indigo-600">
// //                     {article.description}
// //                   </h3>
// //                 </div>
// //               </div>
// //             </Link>

// //             {/* ✅ Inline Ad (every 3 articles) */}
// //             {(index + 1) % 3 === 0 && (
// //               <div className="col-span-full my-6">
// //                 <AdManagerAd id={`div-gpt-ad-inline-${index}`} />
// //               </div>
// //             )}

// //           </React.Fragment>
// //         ))}
// //       </div>

// //       {/* ✅ Sticky Ad (ONLY ONCE) */}
// //       <AdManagerAd
// //         adUnit="/23318400632/Display/sticky"
// //         size={[300, 50]}
// //         divId="div-gpt-ad-1776101443428-0"
// //       />
// //     </div>
// //   );
// // };

// // export default Articles;

// // import React from "react";
// // import { Link } from "react-router-dom";
// // import articles from "./ArticlesBulk";
// // import AdManagerAd from "../JobDetails/AdsenseAd";

// // const Articles = () => {
// //   return (
// //     <div className="min-h-screen bg-gray-50 py-10 px-5">
// //       <h1 className="text-3xl font-bold text-center mb-10 text-gray-800">
// //         Articles
// //       </h1>

// //       <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
// //         {articles.map((article, index) => (
// //           <React.Fragment key={article.id}>

// //             {/* Article Card */}
// //             <Link to={`/articles/${article.id}`}>
// //               <div className="bg-white shadow-lg rounded-2xl p-6 hover:shadow-2xl transition cursor-pointer">
// //                 <h2 className="text-xl font-semibold text-gray-900 mb-2">
// //                   {article.title}
// //                 </h2>

// //                 <div className="border-t border-gray-200 pt-3 mt-3">
// //                   <h3 className="text-lg font-medium text-indigo-600">
// //                     {article.description}
// //                   </h3>
// //                 </div>
// //               </div>
// //             </Link>

// //             {/* ✅ Inline Ad every 3 articles */}
// //             {(index + 1) % 3 === 0 && (
// //               <div className="col-span-full my-6 flex justify-center">
// //                 <AdManagerAd
// //                   adUnit="/23318400632/Display/inline"
// //                   size={[
// //                     [300, 250],
// //                     [336, 280],
// //                     [320, 100],
// //                     [320, 50]
// //                   ]}
// //                   divId={`div-gpt-ad-inline-${index}`}
// //                 />
// //               </div>
// //             )}
// //           </React.Fragment>
// //         ))}
// //       </div>

// //       {/* ✅ Sticky Footer Ad */}
// //       <div style={{
// //         position: "fixed",
// //         bottom: 0,
// //         left: 0,
// //         width: "100%",
// //         display: "flex",
// //         justifyContent: "center",
// //         zIndex: 999
// //       }}>
// //         <AdManagerAd
// //           adUnit="/23318400632/Display/sticky"
// //           size={[300, 50]}
// //           divId="div-gpt-ad-sticky"
// //         />
// //       </div>
// //     </div>
// //   );
// // };

// // export default Articles;


// // import React, { useEffect, useState } from "react";
// // import { useParams } from "react-router-dom";
// // import articles from "./ArticlesBulk";
// // import AdManagerAd from "../JobDetails/AdsenseAd";

// // const ArticleDetail = () => {
// //   const { id } = useParams();
// //   const article = articles.find((a) => a.id === parseInt(id));
// //   const [content, setContent] = useState("");

// //   // ✅ Responsive size mapping
// //   const sizeMapping = [
// //     { viewport: [1024, 0], sizes: [[970, 90], [728, 90]] }, // Desktop
// //     { viewport: [768, 0], sizes: [[468, 60]] },             // Tablet
// //     { viewport: [0, 0], sizes: [[300, 250], [320, 50]] },   // Mobile
// //   ];

// //   useEffect(() => {
// //     if (article?.file) {
// //       fetch(article.file)
// //         .then((res) => res.text())
// //         .then((data) => setContent(data));
// //     }
// //   }, [article]);

// //   if (!article)
// //     return <p className="text-center mt-10">Article not found.</p>;

// //   return (
// //     <div className="max-w-4xl mx-auto py-10 px-5">
// //       <h1 className="text-3xl font-bold mb-5">{article.title}</h1>
// //       <p className="text-gray-700 mb-5">{article.description}</p>

// //       {article.file ? (
// //         <div className="prose max-w-none text-gray-700">
// //           {content.split("\n").map((line, idx) =>
// //             line.trim() ? <p key={idx}>{line}</p> : <br key={idx} />
// //           )}
// //         </div>
// //       ) : (
// //         <div className="border-t border-gray-200 pt-5 space-y-6">
// //           {[...Array(10)].map((_, index) => {
// //             const subtopicKey = `subtopic${index + 1}`;
// //             const descriptionKey = `description${index + 1}`;

// //             if (article[subtopicKey] || article[descriptionKey]) {
// //               return (
// //                 <div key={index}>
// //                   {article[subtopicKey] && (
// //                     <h2 className="text-lg font-medium text-indigo-600">
// //                       {article[subtopicKey]}
// //                     </h2>
// //                   )}

// //                   {article[descriptionKey] && (
// //                     <p className="text-gray-600 mt-1">
// //                       {article[descriptionKey]}
// //                     </p>
// //                   )}

// //                   {/* ✅ Show ad every 2 sections */}
// //                   {(index + 1) % 2 === 0 && (
// //                     <div className="my-4 flex justify-center">
// //                       <AdManagerAd
// //                         adUnit="/23318400632/Display/inline"
// //                         size={[
// //                           [970, 90],
// //                           [728, 90],
// //                           [468, 60],
// //                           [300, 250],
// //                           [320, 50],
// //                         ]}
// //                         sizeMapping={sizeMapping}
// //                         divId={`div-gpt-ad-inline-${index}`}
// //                       />
// //                     </div>
// //                   )}
// //                 </div>
// //               );
// //             }
// //             return null;
// //           })}
// //         </div>
// //       )}

// //       {/* ✅ Sticky Footer Ad */}
// //       {/* <div className="fixed bottom-0 left-0 w-full flex justify-center z-50 bg-white">
// //         <AdManagerAd
// //           adUnit="/23318400632/Display/sticky"
// //           size={[[970, 90], [728, 90], [320, 50]]}
// //           sizeMapping={sizeMapping}
// //           divId="div-gpt-ad-sticky-detail"
// //         />
// //       </div> */}
// //     </div>
// //   );
// // };

// // export default ArticleDetail;



// // import React, { useEffect, useState } from "react";
// // import { useParams } from "react-router-dom";
// // import articles from "./ArticlesBulk";
// // import AdManagerAd from "../JobDetails/AdsenseAd";

// // const ArticleDetail = () => {
// //   const { id } = useParams();
// //   const article = articles.find((a) => a.id === parseInt(id));
// //   const [content, setContent] = useState("");

// //   // ✅ Responsive size mapping
// //   const sizeMapping = [
// //     { viewport: [1024, 0], sizes: [[970, 90], [728, 90]] }, // Desktop
// //     { viewport: [768, 0], sizes: [[468, 60]] },             // Tablet
// //     { viewport: [0, 0], sizes: [[300, 250], [320, 50]] },   // Mobile
// //   ];

// //   // ✅ Optimized fetch
// //   useEffect(() => {
// //     if (!article?.file) return;

// //     fetch(article.file)
// //       .then((res) => res.text())
// //       .then((data) => setContent(data));
// //   }, [article?.file]);

// //   if (!article)
// //     return <p className="text-center mt-10">Article not found.</p>;

// //   return (
// //     <div className="max-w-4xl mx-auto py-10 px-5">
// //       <h1 className="text-3xl font-bold mb-5">{article.title}</h1>
// //       <p className="text-gray-700 mb-5">{article.description}</p>

// //       {article.file ? (
// //         <div className="prose max-w-none text-gray-700">
// //           {content.split("\n").map((line, idx) =>
// //             line.trim() ? <p key={idx}>{line}</p> : <br key={idx} />
// //           )}
// //         </div>
// //       ) : (
// //         <div className="border-t border-gray-200 pt-5 space-y-6">
// //           {[...Array(10)].map((_, index) => {
// //             const subtopicKey = `subtopic${index + 1}`;
// //             const descriptionKey = `description${index + 1}`;

// //             if (article[subtopicKey] || article[descriptionKey]) {
// //               return (
// //                 <div key={index}>
// //                   {article[subtopicKey] && (
// //                     <h2 className="text-lg font-medium text-indigo-600">
// //                       {article[subtopicKey]}
// //                     </h2>
// //                   )}

// //                   {article[descriptionKey] && (
// //                     <p className="text-gray-600 mt-1">
// //                       {article[descriptionKey]}
// //                     </p>
// //                   )}

// //                   {/* ✅ Ad every 3 sections (optimized) */}
// //                   {(index + 1) % 3 === 0 && (
// //                     <div className="my-4 flex justify-center w-full overflow-hidden min-h-[100px]">
// //                       <AdManagerAd
// //                         adUnit="/23318400632/Display/inline"
// //                         size={[
// //                           [970, 90],
// //                           [728, 90],
// //                           [468, 60],
// //                           [300, 250],
// //                           [320, 50],
// //                         ]}
// //                         sizeMapping={sizeMapping}
// //                         divId={`div-gpt-ad-inline-${index}`}
// //                       />
// //                     </div>
// //                   )}
// //                 </div>
// //               );
// //             }
// //             return null;
// //           })}
// //         </div>
// //       )}
// //     </div>
// //   );
// // };

// // export default ArticleDetail;








// import React from "react";
// import { Link } from "react-router-dom";
// import articles from "./ArticlesBulk";
// import AdManagerAd from "../JobDetails/AdsenseAd";

// const Articles = () => {
//   return (
//     <div className="min-h-screen bg-gray-50 py-10 px-5">
//       <h1 className="text-3xl font-bold text-center mb-10 text-gray-800">
//         Articles
//       </h1>

//       <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
//         {articles.map((article, index) => (
//           <React.Fragment key={article.id}>

//             {/* Article Card */}
//             <Link to={`/articles/${article.id}`}>
//               <div className="bg-white shadow-lg rounded-2xl p-6 hover:shadow-2xl transition cursor-pointer">
//                 <h2 className="text-xl font-semibold text-gray-900 mb-2">
//                   {article.title}
//                 </h2>

//                 <div className="border-t border-gray-200 pt-3 mt-3">
//                   <h3 className="text-lg font-medium text-indigo-600">
//                     {article.description}
//                   </h3>
//                 </div>
//               </div>
//             </Link>

//             {/* ✅ Inline Ad every 3 articles */}
//             {(index + 1) % 3 === 0 && (
//               <div className="col-span-full my-6 flex justify-center">
//                 <AdManagerAd
//                   adUnit="/23318400632/Display/inline"
//                   size={[
//                     [300, 250],
//                     [336, 280],
//                     [320, 100],
//                     [320, 50]
//                   ]}
//                   divId={`div-gpt-ad-inline-${index}`}
//                 />
//               </div>
//             )}
//           </React.Fragment>
//         ))}
//       </div>

//       {/* ✅ Sticky Footer Ad */}
//       <div style={{
//         position: "fixed",
//         bottom: 0,
//         left: 0,
//         width: "100%",
//         display: "flex",
//         justifyContent: "center",
//         zIndex: 999
//       }}>
//         <AdManagerAd
//           adUnit="/23318400632/Display/sticky"
//           size={[300, 50]}
//           divId="div-gpt-ad-sticky"
//         />
//       </div>
//     </div>
//   );
// };

// export default Articles;



import React from "react";
import { Link } from "react-router-dom";
import articles from "./ArticlesBulk";
import AdManagerAd from "../JobDetails/AdsenseAd";

const Articles = () => {

  // ✅ Responsive mapping
  const sizeMapping = [
    { viewport: [1024, 0], sizes: [[970, 90], [728, 90]] }, // Desktop
    { viewport: [768, 0], sizes: [[468, 60]] },             // Tablet
    { viewport: [0, 0], sizes: [[300, 250], [320, 50]] },   // Mobile
  ];

  return (
    <div className="min-h-screen bg-gray-50 py-10 px-5 pb-24">
      {/* ✅ Title */}
      <h1 className="text-3xl font-bold text-center mb-10 text-gray-800">
        Articles
      </h1>

      {/* ✅ Articles Grid */}
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
        {articles.map((article, index) => (
          <React.Fragment key={article.id}>

            {/* ✅ Article Card */}
            <Link to={`/articles/${article.id}`}>
              <div className="bg-white shadow-lg rounded-2xl p-6 hover:shadow-2xl transition cursor-pointer">
                <h2 className="text-xl font-semibold text-gray-900 mb-2">
                  {article.title}
                </h2>

                <div className="border-t border-gray-200 pt-3 mt-3">
                  <p className="text-gray-600">
                    {article.description}
                  </p>
                </div>
              </div>
            </Link>

            {/* ✅ Inline Ad every 3 articles */}
            {(index + 1) % 3 === 0 && (
              <div className="col-span-full my-6 flex justify-center w-full overflow-hidden min-h-[100px]">
                <AdManagerAd
                  adUnit="/23318400632/Display/inline"
                  size={[
                    [970, 90],
                    [728, 90],
                    [468, 60],
                    [300, 250],
                    [320, 50],
                  ]}
                  sizeMapping={sizeMapping}
                  divId={`div-gpt-ad-inline-${index}`}
                />
              </div>
            )}

          </React.Fragment>
        ))}
      </div>

      {/* ✅ Sticky Bottom Ad (sticky2) */}
      <div className="fixed bottom-0 left-0 w-full flex justify-center z-50 bg-white shadow-md">
        <AdManagerAd
          adUnit="/23318400632/Display/sticky2"
          size={[[728, 90], [320, 50], [300, 50]]}
          sizeMapping={sizeMapping}
          divId="div-gpt-ad-sticky2"
        />
      </div>

    </div>
  );
};

export default Articles;